module.exports = __webpack_public_path__ + "img/my-tokens-icon.a91a4028.svg";